import React from 'react';

import { Label } from 'semantic-ui-react'

export default function TeamDetails(props) {
  const { teamList } = props;
  return (
    <div className='team-details'>
      <label>Team:</label>
      {
        teamList.map((team)=>{
          return(
            <Label key={team} value={team}>
              {team}
            </Label>
          )
        })
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/team_details.js